<template>
    <v-card class="py-4" :class="$vuetify.display.mobile ? `px-0` : `px6`">
        <v-card-title class="text-h4 text-end mb-4">INFORMÁCIÓK, KAPCSOLAT</v-card-title>
        <v-card-text class="text-start">
            <MdPreview v-if="content" :modelValue="content" />
            <v-progress-circular v-else indeterminate></v-progress-circular>
        </v-card-text>
    </v-card>
</template>
<script>
import { defineComponent } from "vue";
import { MdPreview } from 'md-editor-v3'
import 'md-editor-v3/lib/preview.css'
import { getDynamics } from '../services/dynamicsService'

export default defineComponent({
    name: `InfoPage`,
    components: { MdPreview },
    data() {
        return {
            content: null,
        };
    },
    async mounted() {
        const result = await getDynamics('felhivas')
        if (result) this.content = result.content
    },
});
</script>
